import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { LOGIN_USER, LOGIN_USER_MICROSOFT, LOGOUT_USER } from '../actions'
import { baseUrl } from '../../../services'
import { AccountLogin } from '../../../constants/endPointValues'
import { loginUserError, loginUserSuccess } from './actions'
import { setCurrentUser, setToken } from '../../../helpers/Utils'
import {
  adminRoot,
  localStorageAllStrings
} from '../../../constants/defaultValues'
import { handlerStatusHttpError } from '../../../utils/helpers'

export function* watchLoginUser() {
  yield takeEvery(LOGIN_USER, loginWithEmailPassword)
}

export function* watchLoginUserMicrosoft() {
  yield takeEvery(LOGIN_USER_MICROSOFT, loginWithMicrosoft)
}

function* loginWithEmailPassword({ payload }) {
  const { history, user } = payload
  try {
    const { data } = yield call(baseUrl.post, AccountLogin, user)
    if (data.canAccess == true) {
      const { user } = data

      const currentUser = {
        id: user.id,
        name: user.name,
        email: user.email,
        img: user.imgUrl,
        date: new Date(),
        permissions: user.permissions,
        permissoesEmpresas: user.permissoesEmpresas
      }

      setCurrentUser(currentUser)
      setToken(data.token)

      yield put(loginUserSuccess(currentUser))

      history.push(adminRoot)
    } else {
      yield put(loginUserError(data.status))
    }
  } catch (ex) {
    const errorHandler = handlerStatusHttpError(ex)
    yield put(loginUserError(errorHandler))
  }
}

export function* watchLogoutUser() {
  yield takeEvery(LOGOUT_USER, logout)
}

const logoutAsync = async (history) => {
  history.push('/login')
}

function* logout({ payload }) {
  const { history } = payload
  setCurrentUser()
  setToken()
  yield call(logoutAsync, history)
}

function* loginWithMicrosoft({ payload }) {
  const { history, accessToken, idToken } = payload
  try {
    const requestPayload = {
      token: accessToken,
      access_token: accessToken
    }

    if (idToken) {
      requestPayload.id_token = idToken
    }

    const tokenStorage = localStorage.getItem(
      localStorageAllStrings.tokenStorage
    )

    const headers = {
      'Content-Type': 'application/json'
    }

    if (tokenStorage && tokenStorage.trim() !== '') {
      headers.Authorization = `Bearer ${tokenStorage}`
    } else if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`
    } else if (baseUrl.defaults.headers?.Authorization) {
      headers.Authorization = baseUrl.defaults.headers.Authorization
    }

    if (headers.Authorization) {
      baseUrl.defaults.headers.Authorization = headers.Authorization
    }

    const { data } = yield call(
      baseUrl.post,
      'account/acesso',
      requestPayload,
      {
        headers
      }
    )

    if (data.canAccess == true) {
      const { user } = data

      const currentUser = {
        id: user.id,
        name: user.name,
        email: user.email,
        img: user.imgUrl,
        date: new Date(),
        permissions: user.permissions,
        permissoesEmpresas: user.permissoesEmpresas
      }

      setCurrentUser(currentUser)
      setToken(data.token || accessToken)

      yield put(loginUserSuccess(currentUser))

      history.push(adminRoot)
    } else {
      yield put(loginUserError(data.status))
    }
  } catch (ex) {
    const errorHandler = handlerStatusHttpError(ex)
    yield put(loginUserError(errorHandler))
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchLoginUser),
    fork(watchLoginUserMicrosoft),
    fork(watchLogoutUser)
  ])
}
